export function sanitizeInternalReturnUrl(
    candidate: string | null | undefined,
    currentOrigin: string,
): string | null {
    if (!candidate) return null;

    const trimmed = candidate.trim();
    if (!trimmed.startsWith('/') || trimmed.startsWith('//')) return null;

    try {
        const resolved = new URL(trimmed, currentOrigin);
        if (resolved.origin !== currentOrigin) return null;
        return `${resolved.pathname}${resolved.search}${resolved.hash}`;
    } catch {
        return null;
    }
}

export function sanitizeBrowserRedirectTarget(
    candidate: string | null | undefined,
    currentOrigin: string,
): string | null {
    if (!candidate) return null;

    const trimmed = candidate.trim();
    if (!trimmed || trimmed.startsWith('//')) return null;

    if (trimmed.startsWith('/')) {
        return sanitizeInternalReturnUrl(trimmed, currentOrigin);
    }

    try {
        const resolved = new URL(trimmed);
        if (resolved.protocol !== 'https:' && resolved.protocol !== 'http:') return null;
        return resolved.toString();
    } catch {
        return null;
    }
}
